import loadable from '@loadable/component'

const LoadableManageDigest = loadable(() =>
  import(/* webpackChunkName: "manageDigest" */ './manageDigest')
)

export { LoadableManageDigest as ManageDigestPage }
